/*global jQuery, BulkWP*/
BulkWP.validateUrl = function(that) {
    if (jQuery(that).parent().prev().children('table').find("textarea").val() !== '') {
        return true;
    } else {
        return false;
    }
};
